import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UICardSection from 'UIComponents/card/UICardSection';
import LoadingSkeleton from 'framework-listing-lib/internal/shared/components/LoadingSkeleton';
import { View } from 'foundations-components/components/View';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function GallerySkeleton() {
  return /*#__PURE__*/_jsx(View, {
    "data-test-id": "gallery-skeleton",
    borderWidth: "100",
    borderStyle: "solid",
    borderColor: "border-core-subtle",
    marginBlockEnd: "1100",
    children: /*#__PURE__*/_jsx(Grid, {
      marginInline: "200",
      marginBlockStart: "400",
      children: Array.from({
        length: 12
      }).map((_, idx) => /*#__PURE__*/_jsx(GridItem, {
        paddingInline: "200",
        size: 4,
        children: /*#__PURE__*/_jsxs(UICardWrapper, {
          compact: true,
          children: [/*#__PURE__*/_jsx(UICardSection, {
            children: /*#__PURE__*/_jsx(LoadingSkeleton, {
              blockSize: "28px",
              inlineSize: "230px"
            })
          }), /*#__PURE__*/_jsxs(UICardSection, {
            children: [/*#__PURE__*/_jsx(LoadingSkeleton, {
              blockSize: "20px",
              inlineSize: "150px",
              marginBlockEnd: "100"
            }), /*#__PURE__*/_jsx(LoadingSkeleton, {
              blockSize: "20px",
              inlineSize: "180px",
              marginBlockEnd: "100"
            }), /*#__PURE__*/_jsx(LoadingSkeleton, {
              blockSize: "20px",
              inlineSize: "120px",
              marginBlockEnd: "100"
            })]
          })]
        })
      }, idx))
    })
  });
}